import { gql } from "apollo-boost";

const SET_PASSWORD = gql`
  mutation set_password($password: String!) {
    set_password(password: $password) {
      analytics_data {
        user_id
        user_type
        flow
      }
    }
  }
`;

export default SET_PASSWORD;
